// Czech translations
export default {
  sidebar: {
    menu: "Menu",
    adminSection: "Administrace",
    dashboard: "Přehled",
    employees: "Zaměstnanci",
    workplaces: "Pracoviště",
    statuses: "Stavy",
    automations: "Automatizace",
    tests: "Testy",
    export: "Export",
    asistent: "Asistent",
    requests: "Žádosti",
    activity: "Aktivita",
    broadcastSection: "Komunikace",
    inAppMessages: "Hromadná zpráva",
    userManagement: "Správa uživatelů",
    support: "Podpora",
    logout: "Odhlásit se"
  },
  common: {
    search: "Hledat...",
    add: "Přidat",
    save: "Uložit",
    cancel: "Zrušit",
    delete: "Smazat",
    edit: "Upravit",
    close: "Zavřít",
    confirm: "Potvrdit",
    loading: "Načítá se...",
    error: "Chyba",
    success: "Úspěch",
    actions: "Akce",
    filter: "Filtrovat",
    sort: "Seřadit",
    noData: "Žádná data",
    role: "Role",
    lightMode: "Světlý režim",
    darkMode: "Tmavý režim"
  },
  onboardingFlow: {
    welcome: {
      title: "Vítejte v Effzone 👋",
      subtitle: "Za pár minut budete připraveni na první záznam docházky. Provedeme vás nastavením — pracoviště, zaměstnanci a QR plakát.",
      highlightQr: "QR docházka",
      highlightSms: "SMS pozvánky",
      highlightInsights: "Přehledy a mzdy",
      start: "Pojďme na to",
      skip: "Přeskočit, porozhlédnu se sám",
    },
    wizard: {
      title: "Rychlé nastavení",
      stepPersonalize: "Personalizace",
      personalizeHeading: "Přizpůsobte si Effzone",
      personalizeHint: "Vyberte si jazyk a vzhled — vše lze kdykoli změnit v bočním menu.",
      personalizeNote: "Změny se projeví okamžitě — vyzkoušejte si to.",
      personalizeCompanyLabel: "Název firmy",
      personalizeCompanyPlaceholder: "např. Pekařství Novák",
      personalizeCompanyRequired: "Zadejte název firmy — zobrazí se zaměstnancům v aplikaci i v SMS pozvánce.",
      languageLabel: "Jazyk administrace",
      themeLabel: "Vzhled",
      themeLight: "Světlý",
      themeDark: "Tmavý",
      railHint: "Nastavení zabere pár minut. Vše lze kdykoli změnit — nic není definitivní.",
      stepWorkplace: "Pracoviště",
      stepEmployees: "Zaměstnanci",
      stepPoster: "QR plakát",
      stepDone: "Hotovo",
      workplaceHeading: "Vytvořte první pracoviště",
      workplaceHint: "Místo, kde si zaměstnanci budou označovat příchod — prodejna, sklad, kancelář…",
      workplaceLabel: "Název pracoviště",
      workplacePlaceholder: "např. Prodejna Praha",
      workplaceExisting: "Použije se pracoviště:",
      workplaceSelectHint: "Toto jsou vaše pracoviště — každé má vlastní QR kód. Přidejte jich, kolik potřebujete.",
      employeesAssignLabel: "Přiřadit na pracoviště",
      posterWorkplaceLabel: "Plakát pro pracoviště",
      workplaceAddAnother: "Přidat další pracoviště",
      workplaceCreateBtn: "Vytvořit",
      workplaceRequired: "Zadejte název pracoviště nebo vyberte existující.",
      employeesHeading: "Přidejte zaměstnance",
      employeesHint: "Stačí jméno a telefonní číslo — přihlásí se jím do mobilní aplikace. Automaticky je přiřadíme na pracoviště {workplace}.",
      employeeName: "Jméno",
      employeePhone: "Telefon (+420...)",
      employeePosition: "Pozice (nepovinné)",
      addRow: "Přidat dalšího",
      importTitle: "Hromadný import ze souboru",
      importSubtitle: "Nahrajte Excel či CSV se zaměstnanci — AI rozpozná jména, čísla i pozice, ať jsou sloupce jakékoli.",
      importDrop: "Přetáhněte sem soubor nebo klikněte a vyberte jej",
      importFormats: "Excel (.xlsx), CSV nebo textový soubor · max 5 MB",
      importOrText: "…nebo vložte seznam jako text",
      importBadType: "Nepodporovaný typ souboru. Nahrajte .xlsx, .csv nebo .txt (starý .xls uložte v Excelu jako .xlsx).",
      importPlaceholder: "Sem vložte seznam zaměstnanců…\n\nnapř.:\nJan Novák, 605 123 456, prodavač\nEva Malá\t722 222 333\tskladnice",
      importParse: "Rozpoznat seznam",
      importParsing: "AI čte seznam…",
      importSuccess: "Rozpoznáno {count} zaměstnanců — zkontrolujte a upravte údaje níže.",
      importNone: "V textu se nepodařilo rozpoznat žádné zaměstnance. Zkuste vložit seznam se jmény a čísly.",
      importEmpty: "Nejprve vložte text se seznamem zaměstnanců.",
      sendInvite: "Poslat SMS pozvánku se stažením aplikace",
      employeesNone: "Vyplňte alespoň jednoho zaměstnance nebo krok přeskočte.",
      employeesPartialFail: "Nepodařilo se vytvořit: {names}. Zkontrolujte údaje a zkuste znovu, nebo krok přeskočte.",
      posterHeading: "Vytiskněte QR plakát",
      posterHint: "Pověste ho na pracoviště — zaměstnanci ho naskenují aplikací a docházka se zapíše sama. Obsahuje i návod a QR ke stažení aplikace.",
      posterPrint: "Vytisknout A4 plakát",
      posterPrinted: "Plakát odeslán k tisku 🎉",
      posterLater: "Plakát můžete kdykoli vytisknout i později v detailu pracoviště.",
      doneHeading: "Vše připraveno! 🎉",
      doneText: "Když zaměstnanec naskenuje QR kód na plakátu, první příchod uvidíte přímo na dashboardu.",
      doneSummaryWorkplace: "Pracoviště",
      doneSummaryEmployees: "Zaměstnanci",
      doneSummaryInvites: "SMS pozvánky",
      startTour: "Prohlédnout si administraci (1 min)",
      finish: "Začít používat Effzone",
      back: "Zpět",
      next: "Další",
      skipStep: "Přeskočit tento krok",
      creating: "Pracuji…",
      genericError: "Něco se nepovedlo. Zkuste to prosím znovu.",
    },
    tour: {
      next: "Další",
      prev: "Zpět",
      done: "Hotovo",
      dashboardTitle: "Dashboard",
      dashboardDesc: "Přehled dne na jednom místě — kdo je v práci, odpracované hodiny a trendy týmu.",
      employeesTitle: "Zaměstnanci",
      employeesDesc: "Přidávání zaměstnanců, SMS pozvánky do aplikace a přiřazování na pracoviště.",
      workplacesTitle: "Pracoviště",
      workplacesDesc: "Každé pracoviště má vlastní QR kód. Zde upravíte styl QR a vytisknete A4 plakát.",
      automationsTitle: "Automatizace",
      automationsDesc: "Automatické ukončení směn, připomínky a pravidla — docházka se hlídá sama.",
      exportTitle: "Export",
      exportDesc: "Podklady pro mzdy na pár kliknutí — export docházky do Excelu za zvolené období.",
      asistentTitle: "AI asistent",
      asistentDesc: "Zeptejte se na docházku lidskou řečí — asistent odpovídá z vašich dat.",
      requestsTitle: "Žádosti",
      requestsDesc: "Zaměstnanci posílají žádosti o úpravu docházky z aplikace, vy je zde schvalujete.",
      activityTitle: "Aktivita",
      activityDesc: "Živý přehled všech událostí — příchody, změny a dění ve firmě.",
      profileTitle: "Váš profil",
      profileDesc: "Nastavení účtu, jazyk a tmavý režim najdete zde dole. To je vše — pojďme na to!",
    },
    checklist: {
      runWizard: "Spustit průvodce nastavením",
      runTour: "Prohlídka administrace",
    },
  },
  addEmployeeDrawer: {
    title: "Přidat zaměstnance",
    name: "Jméno",
    position: "Pozice",
    email: "E-mail",
    phone: "Telefonní číslo",
    phoneHelper: "Číslo, kterým se zaměstnanec přihlásí do mobilní aplikace (např. 605 123 456).",
    assignWorkplaces: "Přiřadit k pracovištím",
    workplaceRequiredHint: "Bez přiřazeného pracoviště se zaměstnanec nemůže přihlásit do aplikace.",
    noWorkplaceWarning: "Není vybráno žádné pracoviště — zaměstnanec se nebude moci přihlásit.",
    sendInvite: "Poslat SMS pozvánku do aplikace",
    sendInviteHint: "Zaměstnanci přijde SMS s odkazem na stažení aplikace Effzone.",
    create: "Vytvořit",
    errorRequired: "Jméno a telefonní číslo jsou povinné.",
    errorGeneric: "Zaměstnance se nepodařilo vytvořit. Zkuste to znovu.",
    inviteSmsFailed: "Zaměstnanec byl vytvořen, ale SMS pozvánku se nepodařilo odeslat. Pošlete mu odkaz effzone.sk/mobile-app ručně."
  },
  pages: {
    dashboard: {
      title: "Přehled",
      quickActions: "Rychlé akce",
      addEmployeesTitle: "Přidejte zaměstnance",
      addEmployeesDesc: "Začněte přidáním zaměstnanců do systému pro správu docházky.",
      addEmployeesBtn: "Přidat zaměstnance",
      addWorkplaceTitle: "Vytvořte pracoviště",
      addWorkplaceDesc: "Vytvořte pracoviště a vygenerujte QR kódy pro evidenci docházky.",
      addWorkplaceBtn: "Přidat pracoviště",
      onboarding: {
        title: "Začínáme — 4 kroky k první docházce",
        subtitle: "Hotovo {done} z {total}",
        step1Title: "Vytvořte pracoviště",
        step1Desc: "Stačí název — poloha a geofencing lze doplnit později.",
        step1Btn: "Vytvořit",
        step2Title: "Vytiskněte QR plakát a nalepte ho na pracoviště",
        step2Desc: "V detailu pracoviště stiskněte „Vytisknout A4 plakát“ — obsahuje QR kód i návod pro zaměstnance.",
        step2Btn: "Otevřít pracoviště",
        step3Title: "Přidejte zaměstnance",
        step3Desc: "Jméno + telefonní číslo. Nezapomeňte přiřadit pracoviště — bez něj se zaměstnanec nepřihlásí. Zaměstnanci automaticky odejde SMS s odkazem na aplikaci.",
        step3Btn: "Přidat",
        step4Title: "První příchod",
        step4Desc: "Zaměstnanec si stáhne aplikaci, naskenuje QR na pracovišti a přihlásí se telefonním číslem. Hned ho uvidíte tady na přehledu.",
      },
      presentListTitle: "Aktuálně na pracovišti",
      noPresent: "Momentálně není nikdo na pracovišti.",
      noPosition: "Pozice neuvedena",
      presence: {
        now: "Teď",
        ofTeam: "z {total} lidí je na pracovišti",
        noTeamYet: "Zatím jste nepřidali žádné zaměstnance",
        working: "Pracují",
        onBreak: "Na přestávce",
        away: "Mimo",
        nobodyInHint: "Dnes si zatím nikdo neoznačil příchod.",
        addTeamCta: "Přidat zaměstnance"
      },
      feed: {
        title: "Nástěnka",
        subtitle: "Posledních 20 událostí v týmu",
        updatedAt: "Aktualizováno v {time}",
        today: "Dnes",
        yesterday: "Včera",
        emptyTitle: "Zatím se nic nestalo",
        emptyHint: "Každý příchod, přestávka a odchod se objeví tady — jakmile si první člověk označí příchod.",
        summary: {
          arrivals: "příchodů",
          breaks: "přestávek",
          departures: "odchodů"
        },
        kinds: {
          arrival: "Příchod",
          departure: "Odchod",
          breakStart: "Přestávka",
          breakEnd: "Návrat z přestávky",
          autoEnd: "Ukončeno systémem"
        }
      },
      period: {
        title: "Jak tým pracoval",
        teamLabel: "Průměr týmu",
        byEmployeeLabel: "Podle zaměstnance",
        autoEndedNote: "Ukončeno systémem · {count} — nepočítají se do průměrného odchodu ani času v práci",
        autoEndedShow: "Zobrazit",
        autoEndedHide: "Skrýt"
      },
      filters: {
        employeeAll: "Celý tým",
        employeeLabel: "Zaměstnanec"
      },
      kpis: {
        totalEmployees: "Zaměstnanci celkem",
        atWorkplace: "Na pracovišti",
        onBreak: "Na přestávce",
        workedToday: "Pracovalo dnes",
        workplaces: "Pracoviště",
        checkinsToday: "Načtení dnes",
        checkinsBreakdown: "NFC {nfc} · QR {qr}",
        notPresent: "Nepřítomní",
        onCustomStatus: "Vlastní stav"
      },
      workplacePresence: {
        title: "Kdo je kde teď",
        subtitle: "Aktuálně přítomní na pracovištích",
        noData: "Momentálně není nikdo na pracovišti."
      },
      statusBreakdown: {
        title: "Absence a stavy",
        subtitle: "Za zvolené období",
        noData: "Žádné záznamy o stavech za toto období."
      },
      scoreboard: {
        title: "Přehled zaměstnanců",
        subtitle: "Odpracované hodiny, dny a časy za zvolené období — klikni na hlavičku pro seřazení",
        noData: "Za toto období zatím nejsou žádná docházková data.",
        noDataHint: "Tabulka se naplní, jakmile zaměstnanci začnou označovat příchody a odchody.",
        colEmployee: "Zaměstnanec",
        colHours: "Odpracováno",
        colDays: "Dny",
        colArrival: "Ø příchod",
        colDeparture: "Ø odchod",
        colBreak: "Ø přestávka"
      },
      status: {
        atWorkplace: "Na pracovišti",
        onBreak: "Na přestávce"
      },
      charts: {
        weeklyTrend: "Docházka za 7 dní",
        arrivalsToday: "Příjezdy podle hodiny",
        dayDetail: "Příchody a odchody podle hodiny",
        weekly: "7 dní",
        today: "Dnes",
        byDay: "Po dnech",
        present: "Přítomní",
        arrivals: "Příchody",
        departures: "Odchody",
        clickHint: "Klikněte na sloupec pro zobrazení zaměstnanců v daný den",
        noDayData: "V tento den nejsou žádné záznamy",
        noDayDataHint: "Zkuste jiný den nebo přepněte na sedmidenní přehled.",
        tooltip: {
          presentCount: "Přítomní · {count}",
          stillAtWork: "v práci",
          more: "další: {count}",
          autoEndedNote: "Ukončil systém — čas odchodu není skutečný"
        },
        hoursTrendTitle: "Trend odpracovaných hodin",
        hoursTrendSubtitle: "Čisté hodiny po týdnech",
        netHours: "Odpracované hodiny",
        weekOf: "Týden od {date}"
      },
      tasks: {
        title: "Úkoly",
        subtitle: "Co týmu přibylo a co doběhlo",
        open: "Otevřené",
        openHint: "z toho {inProgress} rozdělaných",
        overdue: "Po termínu",
        overdueHint: "otevřené s termínem v minulosti",
        completed7d: "Hotové (7 dní)",
        created7dHint: "za tu dobu přibylo {created}",
        recentLabel: "Poslední dění",
        unassigned: "Bez řešitele",
        noRecent: "Zatím se nic nedělo.",
        noRecentHint: "Tady se objeví, co přibylo a co se dokončilo.",
        emptyTitle: "Úkoly zatím nikdo nezaložil.",
        emptyHint: "Úkol vzniká v chatu nebo v mobilní aplikaci a vždy patří někomu z týmu. Jakmile ho někdo založí, uvidíte tu, jak se hýbe.",
        statuses: {
          pending: "Zadaný",
          in_progress: "Rozdělaný",
          completed: "Hotový",
          cancelled: "Zrušený"
        },
        priorities: {
          low: "Nízká",
          medium: "Střední",
          high: "Vysoká"
        },
        detail: {
          title: "Detail úkolu",
          assignee: "Řeší",
          createdBy: "Zadal",
          created: "Vytvořen",
          dueDate: "Termín",
          priority: "Priorita",
          completed: "Dokončen",
          notes: "Poznámka",
          attachments: "Přiložené zadání",
          recordings: "Nahrávky",
          openFile: "Otevřít soubor",
          showMore: "Zobrazit celé",
          showLess: "Zobrazit méně",
          truncated: "Soubor je delší — celý se dá otevřít přes odkaz v hlavičce.",
          contentUnavailable: "Obsah se nepodařilo načíst, soubor lze otevřít přes odkaz.",
          errorTitle: "Detail úkolu se nepodařilo načíst.",
          errorHint: "Zkuste to za chvíli znovu. Pokud to potrvá, úkol mohl být mezitím smazán."
        },
        events: {
          created: "Nový",
          completed: "Hotový",
          cancelled: "Zrušený",
          overdue: "Po termínu"
        }
      },
      devices: {
        title: "Zařízení týmu",
        summary: "{employees} zaměstnanců se zaznamenaným zařízením",
        platformsTab: "Platformy",
        appVersionsTab: "Verze aplikace",
        employeesLabel: "Zaměstnanci",
        appVersionsLabel: "Instalace",
        noData: "Zatím nemáme žádná data o zařízeních.",
        noDataHint: "Zařízení se zaznamená, jakmile se zaměstnanec přihlásí v mobilní aplikaci nebo na webu.",
        mobilePlatforms: "Mobilní",
        allPlatforms: "Všechny",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web",
          unknown: "Neznámé"
        }
      },
      analytics: {
        averagesTitle: "Průměry za období",
        averagesTeamSubtitle: "Za celý tým",
        teamTitle: "Výkon týmu",
        periodRange: "Údaje od {from} do {to}",
        sectionRoutine: "Kdy chodí do práce",
        sectionWorkday: "Kolik času stráví v práci",
        sectionActivity: "Aktivita týmu",
        avgArrival: "Příchod do práce",
        avgDeparture: "Odchod z práce",
        avgWork: "Odpracovaný čas za den",
        avgBreak: "Přestávka",
        avgDays: "Odpracované dny",
        activeEmployees: "Aktivní zaměstnanci",
        avgArrivalHint: "V kolik hodin v průměru přicházejí",
        avgDepartureHint: "Kdy v průměru odcházejí domů",
        avgWorkHint: "Čistý čas v práci, bez přestávek",
        avgBreakHint: "Jak dlouho v průměru trvá pauza",
        avgDaysHint: "Kolik dní v průměru odpracuje jeden člověk",
        activeEmployeesHint: "Kolik lidí mělo alespoň jeden záznam",
        consistency: "Stabilita příchodů",
        consistencyHint: "Čím nižší číslo, tím pravidelnější příchody týmu",
        consistencyUnit: "minut rozptyl",
        topByHours: "Nejvíce odpracovaných hodin",
        topByDays: "Nejvíce odpracovaných dní",
        singleEmployeeNote: "Žebříčky jsou dostupné pro celý tým.",
        noData: "Zatím nemáme dostatek dat pro toto období",
        noDataHint: "Průměry se spočítají z prvních dokončených směn.",
        period7: "7 dní",
        period14: "14 dní",
        period30: "30 dní",
        period90: "90 dní",
        period365: "Rok"
      }
    },
    employees: {
      title: "Zaměstnanci",
      addEmployee: "Přidat zaměstnance",
      searchPlaceholder: "Hledat podle jména zaměstnance...",
      list: {
        person: "Zaměstnanec",
        group: {
          working: "V práci",
          onBreak: "Na přestávce",
          done: "Odpracováno",
          away: "Bez záznamu"
        },
        previousDay: "Předchozí den",
        nextDay: "Následující den",
        pickDay: "Vybrat den",
        today: "Dnes",
        shift: "Směna",
        lastSeen: "Naposledy v práci {date}",
        appSeen: "v aplikaci {date}",
        neverUsed: "Aplikaci zatím nepoužil",
        noAttendanceYet: "Aplikaci má, docházku zatím žádnou",
        worked: "Odpracováno",
        workplace: "Pracoviště",
        notify: "Poslat zprávu",
        totalWorked: "celkem {value}",
        emptyTitle: "Žádný zaměstnanec neodpovídá filtru",
        emptyHint: "Zkuste změnit hledání, filtr nebo datum.",
        state: {
          working: "v práci",
          onBreak: "na přestávce",
          done: "odpracováno",
          away: "bez záznamu"
        }
      },
      insights: {
        period30: "30 dní",
        period90: "90 dní",
        period365: "Rok",
        periodLabel: "Přehled za {period}",
        loading: "Načítám statistiky...",
        noDevice: "Bez registrovaného zařízení",
        noAttendance: "Žádná docházka v tomto období",
        avgRoutine: "{arrival} → {departure} · {work}/den · {days} dní",
        deviceTitle: "Zařízení",
        averagesTitle: "Průměry",
        drawerTitle: "Přehled za období",
        avgBreak: "Průměrná přestávka",
        totalHours: "Celkem odpracováno",
        systemVersion: "Verze systému",
        lastDeviceUpdate: "Naposledy aktualizováno",
        avgArrivalShort: "Příchod",
        avgDepartureShort: "Odchod",
        avgWorkShort: "Čas / den",
        avgDaysShort: "Dní",
        platformUnknown: "Neznámá platforma",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web"
        }
      }
    },
    employeeProfile: {
      backToList: "Zaměstnanci",
      openPage: "Otevřít stránku",
      noPosition: "Pozice neuvedena",
      notFound: "Tento zaměstnanec neexistuje",
      notFoundHint: "Možná byl smazán, nebo patří jiné firmě.",
      presence: {
        working: "V práci od {since} · {elapsed}",
        onBreak: "Na přestávce od {since}",
        lastSeen: "Naposledy v práci {when}",
        never: "Zatím bez docházky"
      },
      actions: {
        message: "Napsat",
        edit: "Upravit"
      },
      rhythm: {
        title: "Jak chodí",
        total: "Odpracováno celkem",
        daysWorked: "Odpracované dny",
        verdict: {
          clockwork: "Chodí jako hodinky",
          regular: "Chodí pravidelně",
          varying: "Příchody se rozcházejí",
          irregular: "Chodí nepravidelně",
          noData: "Zatím málo dat",
          sparse: "Přišel méně než polovinu dní",
          none: "Za toto období bez docházky"
        },
        spread: "příchody se liší o ±{min} min",
        coverage: "přišel {worked} z {total} {unit}",
        unitWorkdays: "pracovních dní",
        unitDays: "dní",
        avgDay: "průměrně {value} denně",
        arrivalAround: "příchod kolem {time}",
        missing: "{days} bez záznamu",
        noEnd: "{days} bez odpípnutého odchodu",
        scopeMonth: "Měsíc",
        scopeYear: "Rok",
        previous: "Předchozí období",
        next: "Následující období",
        dayOne: "den",
        dayFew: "dny",
        dayMany: "dní"
      },
      calendar: {
        less: "méně hodin",
        more: "více"
      },
      strip: {
        worked: "Odpracováno",
        open: "Probíhá",
        auto: "Ukončeno systémem",
        status: "Stav",
        missing: "Bez záznamu"
      },
      day: {
        nothing: "V tento den není žádný záznam",
        nothingHint: "Vyberte v kalendáři den s docházkou — zobrazí se jeho průběh.",
        noEndShort: "Neodpípnutý",
        shiftCount: "{count} směny",
        habitMarker: "přerušovaná čára = běžný příchod a odchod",
        autoNote: "Odchod v tento den zapsala automatizace, ne zaměstnanec — odpracovaný čas proto neznáme.",
        deltaLater: "o {value} později než obvykle",
        deltaEarlier: "o {value} dříve než obvykle",
        deltaMore: "o {value} více než průměr",
        deltaLess: "o {value} méně než průměr",
        deltaSame: "jako obvykle",
        noRecords: "Vyberte den v pásu výše — zobrazí se jeho průběh.",
        kinds: {
          arrival: "Příchod",
          departure: "Odchod",
          auto_end: "Ukončeno systémem",
          break_start: "Přestávka",
          status: "Stav"
        }
      },
      attention: {
        title: "Co si všimnout",
        autoEnded: "Zapomenutý odchod · {count} — směnu ukončil systém",
        staleOpen: "Neuzavřená směna · {count} — stále běží z minulého dne",
        pendingRequests: "Žádosti čekající na tebe · {count}",
        statusDays: "{count} dní",
        open: "Otevřít",
        clearTitle: "Nic, co bys musel řešit",
        clearHint: "Za toto období nemá zapomenuté odchody, neuzavřené směny ani čekající žádosti."
      },
      facts: {
        title: "Fakta",
        startDate: "Nástup",
        birthday: "Narozeniny",
        workplaces: "Pracoviště",
        noWorkplace: "Bez přiřazeného pracoviště",
        device: "Zařízení",
        noDevice: "Bez registrovaného zařízení",
        appVersion: "Verze aplikace",
        lastSeen: "Naposledy v práci"
      },
      message: {
        title: "Zpráva pro {name}",
        subject: "Předmět",
        body: "Text zprávy",
        send: "Odeslat",
        sent: "Zpráva odeslána",
        failed: "Zprávu se nepodařilo odeslat"
      },
      edit: {
        title: "Upravit zaměstnance",
        name: "Jméno",
        position: "Pozice",
        email: "E-mail",
        phone_number: "Telefonní číslo",
        workplaces: "Pracoviště",
        noWorkplaceWarning: "Bez pracoviště se zaměstnanec nemůže přihlásit do aplikace.",
        saved: "Změny uloženy",
        failed: "Změny se nepodařilo uložit"
      }
    },
    employeeDrawer: {
      tabs: {
        timeline: "Časová os",
        plan: "Plán dne",
        message: "Zpráva"
      },
      selectedDate: "Vybrané datum",
      dayPlan: {
        loading: "Načítávám plán dne...",
        noPlan: "Zaměstnanec nemá plán pro tento den."
      }
    },
    workplaces: {
      title: "Pracoviště",
      addWorkplace: "Přidat pracoviště",
      searchPlaceholder: "Hledat podle názvu pracoviště...",
      count: "pracovišť",
      noResults: "Nenalezena žádná pracoviště."
    },
    automations: {
      title: "Automatizace",
      description: "Push notifikace a automatické akce při dlouhé přestávce nebo směně.",
      lastRun: "Poslední spuštění",
      neverRun: "Zatím nespuštěno",
      settings: "Nastavení",
      history: "Historie",
      save: "Uložit",
      enable: "Zapnout",
      active: "Zapnuto",
      inactive: "Vypnuto",
      saved: "Nastavení bylo uloženo.",
      enabled: "Automatizace byla zapnuta.",
      toggleError: "Nepodařilo se změnit stav automatizace.",
      saveError: "Nepodařilo se uložit nastavení.",
      fetchError: "Nepodařilo se načíst automatizace.",
      types: {
        long_break: {
          title: "Přestávka",
          description: "Upozorní zaměstnance, pokud je na přestávce příliš dlouho."
        },
        long_shift_reminder: {
          title: "Dlouhá směna",
          description: "Připomene ukončení směny po překročení počtu hodin."
        },
        auto_end_shift: {
          title: "Automatické ukončení",
          description: "Automaticky ukončí směnu a pošle notifikaci."
        }
      },
      fields: {
        durationMinutes: "Trvání (minuty)",
        durationHours: "Trvání (hodiny)",
        notificationTitle: "Titulek notifikace",
        notificationMessage: "Text notifikace",
        helperBreak: "Upozornit, pokud je přestávka delší než tato hodnota.",
        helperShiftReminder: "Poslat připomínku, pokud je směna delší než tato hodnota.",
        helperAutoEnd: "Automaticky ukončit směnu po překročení této hodnoty.",
        placeholdersEmployee: "Můžete použít {{employee_name}}.",
        placeholdersHours: "Můžete použít {{employee_name}} a {{hours}}."
      },
      historyPanel: {
        emptyTitle: "Zatím žádná historie",
        emptyDesc: "Tato automatizace ještě nebyla spuštěna.",
        success: "Úspěšné",
        failed: "Selhalo",
        unknownEmployee: "Neznámý zaměstnanec"
      }
    },
    requests: {
      title: "Žádosti o změny",
      description: "Schvalte nebo zamítněte žádosti o změny od vašich zaměstnanců.",
      searchPlaceholder: "Hledat podle jména zaměstnance...",
      approve: "Schválit",
      reject: "Zamítnout",
      pending: "Čekající",
      approved: "Schválené",
      rejected: "Zamítnuté",
      noRequests: "Nenalezeny žádné čekající žádosti."
    },
    reports: {
      title: "Podpora — hlášení",
      description: "Hlášení problémů, která uživatelé odeslali zatřesením telefonu. Po vyřešení dostane uživatel zprávu do chatu s AI asistentem.",
      filterOpen: "Nevyřízené",
      filterResolved: "Vyřešené",
      filterAll: "Všechna",
      statusOpen: "Nevyřízené",
      statusResolved: "Vyřešené",
      empty: "Žádná hlášení.",
      loadError: "Nepodařilo se načíst hlášení.",
      detailTitle: "Detail hlášení",
      descriptionLabel: "Popis problému",
      screenshotLabel: "Screenshot",
      diagnostics: "Diagnostika",
      detailScreen: "Obrazovka",
      detailAppVersion: "Verze aplikace",
      detailSystem: "Systém",
      detailDevice: "Zařízení",
      createdAt: "Odesláno",
      markResolved: "Označit jako vyřešené",
      resolveDialogTitle: "Vyřešit hlášení",
      resolveDialogText: "Uživateli pošleme do chatu s AI asistentem zprávu, že jeho podnět je vyřešený. Můžete přidat krátkou poznámku (např. co jste opravili).",
      resolveNoteLabel: "Poznámka pro uživatele (volitelné)",
      resolveNotePlaceholder: "Např.: Opraveno v další verzi, děkujeme!",
      resolvedSuccess: "Hlášení vyřešeno, uživatel byl upozorněn.",
      resolveError: "Nepodařilo se vyřešit hlášení.",
      resolvedAtLabel: "Vyřešeno"
    },
    userManagement: {
      title: "Správa uživatelů",
      description: "Spravujte všechny registrované uživatele",
      searchPlaceholder: "Hledat podle uživatelského jména, emailu nebo společnosti..."
    },
    asistent: {
      heroTitle: "AI Asistent",
      heroSubtitle: "Nahrané dokumenty tvoří znalostní bázi pro AI asistenta v mobilní aplikaci vašich zaměstnanců. Zde můžete spravovat obsah a otestovat odpovědi před nasazením.",
      stepUpload: "Nahraj dokumenty",
      stepManage: "Spravuj znalostní bázi",
      stepTest: "Otestuj odpovědi",
      uploadTitle: "Nahrát dokumenty",
      uploadHint: "Podporované formáty",
      selectFile: "Vybrat soubor",
      uploadButton: "Nahrát",
      dragDropHint: "Přetáhněte soubor sem nebo klikněte pro výběr",
      documentsTitle: "Znalostní báze",
      documentsEmpty: "Zatím žádné nahrané dokumenty. Nahrajte první dokument a asistent ho začne používat.",
      chatTitle: "Testovací chat",
      chatHint: "Vyzkoušejte, jak asistent odpovídá na otázky z nahraných dokumentů.",
      chatPlaceholder: "Napište testovací otázku...",
      chatYou: "Vy",
      chatAssistant: "Asistent",
      uploadSuccess: "Dokument nahrán.",
      uploadSelectError: "Vyberte soubor.",
      uploadFailed: "Nahrání selhalo.",
      chatFailed: "Odpověď se nepodařila.",
      sendButton: "Odeslat",
    },
    inAppMessages: {
      editor: {
        steps: {
          template: "Typ",
          content: "Obsah",
          style: "Styl",
          audience: "Cílová skupina"
        },
        templateSelector: {
          topBanner: "Horní banner",
          topBannerDesc: "Méně rušivý, posouvá se shora.",
          centerModal: "Centrální modál",
          centerModalDesc: "Vysoká pozornost, centruje se na obrazovce.",
          fullScreen: "Celá obrazovka",
          fullScreenDesc: "Maximální dopad, pokrývá vše."
        },
        contentEditor: {
          title: "Nadpis",
          body: "Text zprávy",
          imageUrl: "URL obrázku",
          showImage: "Zobrazit obrázek",
          primaryButton: "Primární tlačítko",
          secondaryButton: "Sekundární tlačítko",
          secondaryButtonHint: "Toto tlačítko pouze zavře zprávu.",
          fullScreenSecondaryHint: "Pro full screen šablonu musí být tlačítko 'Zavřít'.",
          magicGenerator: "AI Generátor",
          magicPromptPlaceholder: "Zadejte téma zprávy (např. 'Speciální nabídka 20% sleva')",
          autoFill: "Automaticky vyplnit",
          generating: "Generuje se...",
          generatingShort: "Generuje..."
        },
        actionEditor: {
          title: "Nastavení primární akce",
          inAppScreen: "In-App obrazovka",
          externalLink: "Externí odkaz",
          screenName: "Název obrazovky",
          urlAddress: "URL adresa",
          parameters: "Parametry (JSON)",
          parametersHint: "Volitelná data předaná obrazovce.",
          placeholderScreen: "např. ProductDetails",
          placeholderUrl: "https://..."
        },
        destinations: {
          selectDestination: "Kam přesměrovat po kliknutí",
          destinationHint: "Vyberte obrazovku v aplikaci. Parametry navigace jsou přednastavené.",
          home: { label: "Domů", desc: "Hlavní feed příspěvků" },
          chat_list: { label: "Chat", desc: "Seznam konverzací" },
          attendance: { label: "Docházka", desc: "Kalendář a směny" },
          settings: { label: "Nastavení", desc: "Profil a nastavení účtu" },
          create_post: { label: "Nový příspěvek", desc: "Vytvoření příspěvku" },
          qr_scanner: { label: "Skenovat QR", desc: "Docházkový QR skener" },
          colleagues: { label: "Kolegové", desc: "Seznam kolegů" },
          permissions: { label: "Oprávnění", desc: "Oprávnění aplikace" },
          wellbeing: { label: "Wellbeing", desc: "Zpětná vazba a wellbeing" },
          about: { label: "O aplikaci", desc: "Informace o aplikaci" },
          search: { label: "Vyhledávání", desc: "Globální vyhledávání" },
        },
        styleEditor: {
          colorPalette: "Paleta barev",
          typography: "Typografie",
          layout: "Rozložení",
          image: "Obrázek",
          background: "Pozadí",
          textColor: "Barva textu",
          primaryBtnBg: "Pozadí prim. tlačítka",
          primaryBtnText: "Text prim. tlačítka",
          secondaryBtnBg: "Pozadí sek. tlačítka",
          secondaryBtnText: "Text sek. tlačítka",
          overlayColor: "Barva překrytí",
          titleSize: "Velikost nadpisu",
          bodySize: "Velikost textu",
          cornerRadius: "Zaoblení rohů",
          imageSize: "Velikost obrázku",
          imageBorderRadius: "Zaoblení obrázku"
        },
        footer: {
          nextStep: "Další krok",
          selectAudience: "Vyberte cílovou skupinu pro pokračování"
        },
        mobileTabs: {
          editor: "Editor",
          preview: "Náhled"
        }
      },
      audience: {
        title: "Vybrat cílovou skupinu",
        searchPlaceholder: "Hledat zaměstnance...",
        filterActiveAttendance: "Pouze zaměstnanci s aktivní docházkou",
        employees: "zaměstnanců",
        employee: "zaměstnanec",
        withFcmToken: "s FCM tokenem",
        selectAll: "Vybrat vše",
        deselectAll: "Zrušit výběr",
        noEmployeesFound: "Nenalezeni žádní zaměstnanci",
        active: "Aktivní",
        noFcmToken: "Bez FCM tokenu",
        selected: "vybraných",
        previewAndSend: "Náhled a odeslání"
      },
      preview: {
        title: "Náhled a odeslání",
        back: "Zpět",
        edit: "Upravit",
        selected: "Vybraných",
        withFcmToken: "S FCM tokenem",
        withoutToken: "Bez tokenu",
        warningNoToken: "vybraných zaměstnanců nemá FCM token a budou přeskočeni.",
        pushNotification: "Push notifikace (když je aplikace na pozadí)",
        inAppMessagePreview: "Náhled in-app zprávy",
        realtimePreview: "Náhled v reálném čase",
        realtimePreviewDesc: "Podívejte se, jak bude vaše zpráva vypadat na zařízení",
        iLikeIt: "Líbí se mi to",
        iDontLikeIt: "Nelíbí se mi to - Upravit",
        approved: "Schváleno ✓",
        sendMessages: "Odeslat zprávy",
        sending: "Odesílá se...",
        copy: "Kopírovat",
        copied: "Zkopírováno!",
        payload: "Payload"
      },
      defaults: {
        title: "📢 Posílejte zprávy všem najednou",
        body: "Vytvořte si vlastní design zprávy a pošlete ji všem vybraným zaměstnancům. Rychlé, jednoduché a efektivní! ✨",
        buttonText: "Začít",
        secondaryButtonText: "Zavřít"
      },
      success: {
        messagesSent: "Zprávy odeslány!",
        successful: "úspěšných",
        failed: "neúspěšných"
      },
      errors: {
        loadingEmployees: "Chyba při načítání zaměstnanců. Zkuste to znovu.",
        sendingMessages: "Chyba při odesílání zpráv. Zkuste to znovu.",
        generatingContent: "Chyba při generování obsahu. Zkuste to znovu."
      }
    }
  }
};

